import React from 'react'
import { Modal, Form, Select, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import { StopOutlined } from '@ant-design/icons'

interface HoldOrderFormValues {
  reason: string;
  note?: string;
}

interface HoldOrderModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (values: HoldOrderFormValues) => void;
  orderName: React.ReactNode;
  confirmLoading?: boolean;
  initialReason?: string;
}

const HoldOrderModal: React.FC<HoldOrderModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  orderName,
  confirmLoading = false,
  initialReason = 'manual_intercept',
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm<HoldOrderFormValues>()

  const reasons = [
    'manual_intercept',
    'merchant_request',
    'platform_cancel',
    'risk_control',
    'address_issue',
    'convenience_store_issue',
    'inventory_discrepancy',
    'other'
  ]

  const handleOk = () => {
    form.validateFields().then(values => {
      onConfirm(values)
    })
  }

  return (
    <Modal
      title={
        <span>
          <StopOutlined style={{ color: '#ff4d4f', marginRight: '8px' }} />
          {t('shared.orders.detail.actions.hold_confirm_title')}
        </span>
      }
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      okText={t('common.button.confirm')}
      cancelText={t('common.button.cancel')}
      okButtonProps={{ danger: true }}
      destroyOnHidden
    >
      <div style={{ marginBottom: '16px' }}>
        {t('shared.orders.detail.actions.hold_confirm_content', { orderName })}
      </div>

      <Form
        form={form}
        layout="vertical"
        initialValues={{ reason: initialReason }}
      >
        <Form.Item
          name="reason"
          label={t('shared.orders.detail.actions.hold_reason_label')}
          rules={[{ required: true }]}
        >
          <Select>
            {reasons.map(r => (
              <Select.Option key={r} value={r}>
                {t(`enums.order_hold.reason.${r}`)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="note"
          label={t('shared.orders.detail.actions.hold_note_label')}
        >
          <Input.TextArea
            rows={4}
            placeholder={t('shared.orders.detail.actions.hold_note_placeholder')}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default HoldOrderModal
